<dx-scroll-view [height]="height">
  <dx-draggable class="drop-area"
    data="dropArea"
    [group]="group"
    (onDragStart)="onListDragStart($event)">
    <dx-draggable
      class="item dx-card dx-theme-text-color dx-theme-background-color"
      [clone]="true"
      [group]="group"
      [data]="task"
      (onDragStart)="onItemDragStart($event)"
      (onDragEnd)="onItemDragEnd($event)"
      *ngFor="let task of tasks">
        <div class="drag-icon dx-icon-dragvertical"></div>
        <div class="color" [class]="task.color"></div>
        <div [class.grouped]="task.subTasks"></div>
        {{task.text}}
        <div [id]="task.id" *ngIf="showMore" class="more-button" (mouseenter)="moreButtonMouseEntered.emit(task)" (mouseleave)="moreButtonMouseLeft.emit()">
          <span class="text dx-icon-more"></span>
        </div>
        <div *ngIf="showMore" class="manual-button" [title]="languageService.LNG('Label.Production.Pane.ManuallyCustom1')" (click)="manualButtonClicked.emit(task)">
          <span class="text">M</span>
        </div>
      </dx-draggable>
  </dx-draggable>
</dx-scroll-view>
